import { injectable } from 'inversify';
import { ILoggerService } from './interfaces';
import BrowserService from './BrowserService';
import ApiService from './ApiService';
import DIContainer from '../config/di.container';
import DITYPES from '../config/di.types';
import moment from 'moment';


const noOfLastLogsSendToServer = 10;
const style = {
  WARN: 'color: #ffc107',
  INFO: 'color: green'
}
const REACT_APP_CONSOLE_REQUIRED: string = process.env.REACT_APP_CONSOLE_REQUIRED || "";

@injectable()
class LoggerSerivce implements ILoggerService {
  logQueue: string[] = [];
  browserService: BrowserService;
  //public apiService: ApiService;

  constructor() {
    this.browserService = DIContainer.get<BrowserService>(DITYPES.BrowserService);
    //this.apiService = DIContainer.get<ApiService>(DITYPES.ApiService);
  }

  enqueueLog = (message: string, logLevel: string) => {
    const logLength = this.logQueue.push(`${moment().format()} ${logLevel} ${message}`);
    if (logLength > noOfLastLogsSendToServer * 2) {
      this.logQueue = this.logQueue.slice(logLength - noOfLastLogsSendToServer, logLength);
    }
  }
  getLastNLogs = () => {
    const logLength = this.logQueue.length;
    return this.logQueue.slice(
      logLength > noOfLastLogsSendToServer ? (logLength - noOfLastLogsSendToServer) : 0,
      logLength,
    );
  }
  info = (message: string) => {
    this.enqueueLog(message, 'INFO');
    if (parseInt(REACT_APP_CONSOLE_REQUIRED)) {
      console.log(this.formatConsoleString(message), style.INFO);
    }
  }
  warn = (message: string) => {
    this.enqueueLog(message, 'WARN');
    if (parseInt(REACT_APP_CONSOLE_REQUIRED)) {
      console.warn(this.formatConsoleString(message), style.WARN);
    }
  }
  error = (message: string) => {
    this.enqueueLog(message, 'ERROR');
    if (parseInt(REACT_APP_CONSOLE_REQUIRED)) {
      console.error(this.formatConsoleString(message), style.WARN);
    }
    const loggerInfoJson = {
      message,
      LastNLogs: this.getLastNLogs(),
      //   BrowserInformation: this.browserService.getBrowserInfo(),
    };
    // this.postLogger(loggerInfoJson);
  }

  formatConsoleString(message: string) {
    return "%c" + moment().format() + " " + message;
  }
}

export default LoggerSerivce;